// extracted by mini-css-extract-plugin
module.exports = {"geoLocation":"GeoLocation-module--geoLocation--1hpNm"};